import React, { Component } from 'react'

export default class Introduction extends Component {
    render() {
        return (
            <section className="section">
                <section className="container">
                <section className="content">
                <h3>Introduction</h3>
                <hr></hr>
                <p>The Carbon Intensity API was built in order to allow developers to produce applications that will enable consumers to optimise their behaviour and minimise CO2 emissions. The API holds data relating to emissions from electricity generation only; including large metered power stations, interconnector imports, transmission and distribution losses. For more information please visit the official <a href="https://carbonintensity.org.uk/">here.</a></p>
                </section>
                </section>
            </section>
        )
    }
}
